require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-dynamics-365-business-architecture.json") })
        }
      }, "path---service-dynamics-365-business-architecture");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-dynamics-365-business-architecture!./.cache/json/service-dynamics-365-business-architecture.json
// module id = 909
// module chunks = 231608221292675